class ProductCard extends HTMLElement {
  static selectors = {
    btn: '[data-add]',
    sizeBtn: '.btn',
    variantPicker: 'variant-picker',
    id: '[name="id"]',
    loader: '[data-card-loader]',
    price: '[data-price]',
    sizeContainer: '[data-size-container]',
    sizes: '.card-sizes'
  };
  static classes = {
    sizes: 'size-active'
  };
  btn; variantPicker; variant; loader; sizes;

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.btns = this.querySelectorAll(ProductCard.selectors.btn);
    this.inputid = this.querySelector(ProductCard.selectors.id);
    this.variantPicker = this.querySelector(ProductCard.selectors.variantPicker);
    this.loader = this.querySelector(ProductCard.selectors.loader);
    this.sizeContainer = this.querySelector(ProductCard.selectors.sizeContainer);
    this.sizes = this.querySelector(ProductCard.selectors.sizes);

    if(this.variantPicker){
      this.variantPicker.addEventListener(Utils.VARIANT_CHANGED, (e) => {
        this.changeVariant(e.detail);
      });
    } 

    if(this.btns){
      this.btns.forEach((btn) => {
        btn.addEventListener('click', () => {
          this.add();
        });
      });
    }

    if(this.sizeContainer && this.sizes){
      const sizeBtn = this.sizeContainer.querySelector(ProductCard.selectors.sizeBtn);
      sizeBtn.addEventListener('mouseover', (e) => {
        console.log('hover');
        this.classList.add(ProductCard.classes.sizes);
      });
      this.sizeContainer.addEventListener('mouseleave', (e) => {
        console.log('leave');
        this.classList.remove(ProductCard.classes.sizes);
      });
    }
  }

  changeVariant = (detail) => {
    this.variant = detail.variant;
    if(this.inputid != undefined){
      this.inputid.value = this.variant.id;
    }
    if(this.querySelector(ProductCard.selectors.price) != undefined){
      this.querySelector(ProductCard.selectors.price).innerText = Utils.money(this.variant.price);
    }
    if(detail.input.dataset.variantAdd !== undefined){
      this.add();
    }
  }

  add = () => {
    Utils.addTocart({
      form: this.querySelector('form'),
      beforeAdd: (id) => {
        this.openLoader();
      },
      finally: () => {
        this.closeLoader();
      }
    });
  }

  openLoader = () => {
    if(this.loader != undefined){
      this.loader.classList.remove('d-none');
    }
  }

  closeLoader = () => {
    if(this.loader != undefined){
      this.loader.classList.add('d-none');
    }
  }
}
if (!window.customElements.get("product-card")) {
  window.customElements.define("product-card", ProductCard);
}
